<template>
  <v-container
    fluid
    class="pa-0 ma-0"
    style="background-color: #f5f7fa"
    id="observer-box"
  >
    <v-row justify="center" style="margin-top: -80px">
      <v-col cols="11" sm="10" md="8">
        <about-me />
      </v-col>
    </v-row>
    <div
      class="divider-svg divider-svg__curve-grey"
      style="margin-top: -40px"
    ></div>
    <v-row justify="center" style="background-color: #ffffff">
      <v-col cols="11" sm="10" md="8">
        <tech-stacks />
      </v-col>
    </v-row>
    <div
      class="divider-svg divider-svg__curve-white"
      style="margin-top: -40px"
    ></div>
    <v-row justify="center">
      <v-col cols="11" sm="10" md="8">
        <tech-projects />
      </v-col>
    </v-row>
    <div
      class="divider-svg divider-svg__curve-grey-2"
      style="margin-top: -40px"
    ></div>
    <v-row
      justify="center"
      style="background-color: #ffffff; margin-top: -40px"
    >
      <v-col cols="11" sm="10" md="8">
        <work-experience />
        <br />
      </v-col>
    </v-row>
    <div
      class="divider-svg-footer divider-svg__curve-footer"
      style="margin-top: -40px; background-color: white;"
    ></div>
  </v-container>
</template>

<script>
import AboutMe from './contents/AboutMe.vue';
import TechStacks from './contents/TechStacks.vue';
import TechProjects from './contents/TechProjects.vue';
import WorkExperience from './contents/WorkExperience.vue';

export default {
  name: 'HomeContent',

  components: {
    AboutMe,
    TechStacks,
    TechProjects,
    WorkExperience,
  },

  data: () => ({
    //
  }),
};
</script>

<style lang="scss">
.divider-svg {
  aspect-ratio: 960/150;
  width: 100%;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}

.divider-svg-footer {
  aspect-ratio: 960/100;
  width: 100%;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}

.divider-svg__curve-grey {
  background-image: url('../../assets/divider-svgs/wave-grey-white-1.svg');
}

.divider-svg__curve-grey-2 {
  background-image: url('../../assets/divider-svgs/wave-grey-white-2.svg');
}

.divider-svg__curve-white {
  background-image: url('../../assets/divider-svgs/wave-white-grey-1.svg');
}

.divider-svg__curve-footer {
  background-image: url('../../assets/divider-svgs/wave-footer.svg');
}
</style>
